const MessageTail = ({ isFromConsumer = false }) => {
  if (isFromConsumer) {
    return (
      <div
        className="absolute right-0 bottom-0"
        style={{
          width: '20px',
          height: '25px',
          backgroundColor: '#000033',
          clipPath: 'polygon(0 0, 0 100%, 100% 100%)',
          transform: 'translateX(50%)',
          marginBottom: '0',
          zIndex: 10
        }}
      />
    )
  }

  return (
    <div
      className="absolute left-0 bottom-0"
      style={{
        width: '25px',
        height: '25px',
        backgroundColor: 'white',
        clipPath: 'polygon(0 0, 0 100%, 100% 100%)',
        transform: 'translateX(-50%) rotate(-90deg)',
        marginBottom: '0',
        zIndex: 10
      }}
    />
  )
}

export default MessageTail

